/**
 * @deprecated Volt migration shim. This entry-point re-export is retained only
 * while consumers migrate off the barrel; import directly from the implementation
 * module instead.
 */
export {
	components,
	createFilter,
	mergeStyles,
	type CSSObjectWithLabel,
} from '@atlaskit/react-select';
